module.exports = __webpack_public_path__ + "static/media/search-dark.8420619e.svg";